<template>
  <div class="sn-f-b-s payment">
    <sn-navigator id="FYCX" :initial="initial"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s payment-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', initial) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 payment-blank">
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ paymentType === '1' ? '就诊人' : '住院人' }}：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到{{ paymentType === '1' ? '就诊人' : '住院人' }}，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <template v-else-if="patientArray.length === 0">
              <div v-if="paymentType === '1'" @click="navigateUrl('addition-patient');">
                暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
              </div>
              <div v-else @click="navigateUrl(isOpenSingleCard ? 'addition-patient' : '/patient/out/homepage');">
                暂无住院人，<span class="sn-pointer sn-fc-main">点击添加</span>
              </div>
            </template>
            <template v-else>
              <el-select :value="selectedPatient.patientId" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>
          <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : ['就诊卡', '住院号'][paymentType - 1] }}：</div>
            </div>
            <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
              {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
            </div>
            <div v-else>
              <el-input readonly="readonly" v-model="outCardSerialFormat"></el-input>
            </div>
          </div>
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>日期范围：</div>
            </div>
            <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">-</div>
          <div class="sn-f-s-c region">
            <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div>
        <template v-if="!$sn.validate.empty(handlePayment)">
          <div class="total-title">消费总金额：{{$sn.format.priceFormat(totalCost, 2)}}元</div>
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>就诊人</th>
                  <th>手机号</th>
                  <th>性别</th>
                  <th>费用名称</th>
                  <th>消费时间</th>
                  <th>金额（元）</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(payment, index) in handlePayment">
                  <td>{{ index + 1 }}</td>
                  <td>{{selectedPatient.patientName}}</td>
                  <td>{{$sn.encrypted.phone(selectedPatient.patientPhone)}}</td>
                  <td>{{$sn.format.sex(selectedPatient.patientSex)}}</td>
                  <td>{{payment.feeName || payment.feeType}}</td>
                  <td>{{payment.feeDate || payment.balanceDate}}</td>
                  <td>{{payment.totalCost === 0 ? '0.00' : $sn.format.priceFormat(payment.totalCost, 2)}}</td>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/payment/detail', payment, {type: paymentType});">查看详情</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
          <div class="sn-f-c-c prompt-message">列表仅显示两个月内费用记录、更多记录请按时间筛选查询</div>
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(paymentInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
      <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" :type="isOpenSingleCard ? '1' : paymentType" @sendBack="sendBackBindCard"></bind-card>
    </div>

    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  mixins: [PatientShareMixin],
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  data() {
    return {
      paymentType: '1',
      patientArray: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      startDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', self.$sn.getConfig('outRechargeRecordRange')[0], self.$sn.getConfig('outRechargeRecordRange')[1]), // 开始日期
      endDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'), // 结束日期
      paymentInfo: [],
      pageCount: 1,
      isResult: true,
      totalCost: 0,
      exhibitionCreatePatient: false,
      exhibitionBindCard: false,
      isOpenSingleCard: self.$sn.getConfig('isOpenSingleCard')
    };
  },
  computed: {
    // 处理费用信息
    handlePayment() {
      let handle = [];
      if (this.paymentInfo.length > 0) handle = this.$sn.format.group(this.paymentInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    },

    // 当前功能 ID
    initial() {
      return [this.perpetual.FUNCTION_ID_MZFY, this.perpetual.FUNCTION_ID_ZYFY][this.paymentType - 1];
    }
  },
  watch: {
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.paymentInfo = [];
      this.pageCount = 1;
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient, this.paymentType);
        if (handle.code >= 0) {
          this.outCardSerial = handle.data.no;
          this.outCardSerialFormat = handle.data.caption;
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && handle.code === 0) this.outCardSerialFormat = patient.idCardEncrypt;
        }
        if (this.outCardSerial) this.searchBtn();
        else {
          const compare = {
            [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
          };
          this.$sn.assembly.modal({
            caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
            success: (modal) => {
              if (modal.confirm) {
                this.navigateUrl('addition-card');
              }
            }
          });
        }
      }
    },
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || !this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.paymentInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.searchBtn();
        }
      },
      immediate: true
    },

    $route(val, old) {
      if ((old.path === '/query/payment' && val.path !== '/query/payment/detail') || (old.path === '/query/payment/detail' && val.path !== '/query/payment')) {
        this.funLoad();
      }
      else if (old.path === '/query/payment/detail' && val.path === '/query/payment') {
        if (this.paymentType !== this.$route.query.type) {
          this.funLoad();
        }
      }
    }
  },
  created: function() {
    this.funLoad();
  },
  methods: {
    funLoad() {
      this.paymentType = this.$route.query.type || '1';
      document.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.initial);
      this.handlePatientInfo();
    },
    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.paymentType === '2') {
        // 住院人 - 含有住院号
        if (!this.isOpenSingleCard) {
          this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
        }
      }
      if (this.patientArray && this.patientArray.length > 0) {
        if (this.paymentType === '1') {
          this.selectedPatient = this.$sn.utils.getCurrentPatient();
        }
        else {
          if (this.isOpenSingleCard) this.selectedPatient = this.$sn.utils.getCurrentPatient() || this.patientArray[0];
          else this.selectedPatient = this.patientArray.find(item => item.inCardNo) || this.patientArray[0];
        }
      }
    },
    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    // 查询门诊费用
    searchBtn() {
      if (!this.outCardSerial) {
        const compare = {
          [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
        };
        this.$sn.assembly.modal({
          caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
          success: (modal) => {
            if (modal.confirm) this.navigateUrl('addition-card');
          }
        });
      }
      else {
        if (this.$sn.validate.empty(this.startDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['开始日期']));
          return false;
        }
        if (this.$sn.validate.empty(this.endDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['结束日期']));
          return false;
        }
        const start = new Date(this.startDate).getTime();
        const end = new Date(this.endDate).getTime();
        if (end < start) {
          this.getShowToast('结束日期不能早于开始日期');
          return false;
        }
        let params = {
          url: Swagger.getPaymentTable,
          method: 'POST',
          header: true,
          data: JSON.stringify({
            cardNo: this.outCardSerial,
            endDate: this.endDate,
            hosId: this.$sn.utils.getHospitalId(),
            idCardNo: this.selectedPatient.patientIdCardNo,
            page: this.pageCount,
            patId: this.selectedPatient.patientId,
            patName: this.selectedPatient.patientName,
            platformId: this.$sn.utils.getPlatformType(),
            platformUserId: this.$sn.utils.getOpenId(),
            projectType: this.$sn.utils.getProjectType(),
            size: this.perpetual.PAGINATION_SIZE,
            startDate: this.startDate

          })
        };
        if (this.paymentType === '2') {
          params = {
            url: Swagger.getPaymentInTable,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              cardNo: this.outCardSerial,
              endDate: this.endDate,
              hosId: this.$sn.utils.getHospitalId(),
              idCardNo: this.selectedPatient.patientIdCardNo,
              page: this.pageCount,
              patId: this.selectedPatient.patientId,
              patName: this.selectedPatient.patientName,
              platformId: this.$sn.utils.getPlatformType(),
              platformUserId: this.$sn.utils.getOpenId(),
              projectType: this.$sn.utils.getProjectType(),
              size: this.perpetual.PAGINATION_SIZE,
              startDate: this.startDate
            })
          };
        }
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params).then(result => {
          this.$sn.assembly.loading(false);
          if (result && result.code === 0 && result.data && result.data.length > 0) {
            this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
            if (this.pageCount === 1) {
              this.paymentInfo = result.data;
              this.totalCost = result.totalFee || 0;
            }
            else this.paymentInfo = this.paymentInfo.concat(result.data);
          }
          else this.isResult = false;
        });
      }
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.paymentInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/query/payment/detail' && !this.$sn.validate.empty(item)) {
        item.cardNo = this.outCardSerial;
        this.$sn.utils.setHospitalSessionStorage('payment_Info', item);
      }
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.payment {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .payment-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .total-title {
        font-size: 16px;
        margin: 0 20px 20px;
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
